import { useQuery } from "@tanstack/react-query";
import { getTaskLocations } from "../../api/tasks/taskLocations";

export default function useTaskLocations() {
  const {
    isLoading,
    isFetching,
    error,
    data: taskLocations,
  } = useQuery<string[]>({
    queryKey: ["taskLocations"],
    queryFn: () => getTaskLocations(),
  });

  return {
    isLoading: isLoading || isFetching,
    error,
    taskLocations,
  };
}
